import { CallStore } from "store/call";

const useCallHandler = () => CallStore.useState(callState => callState);

export { useCallHandler };
